import React from "react";

/* ─────────────────────────────────────────────
   Skeleton — animated placeholder used while
   content is loading. Renders a pulsing block
   that matches the rough shape of the element
   that will replace it.
   ───────────────────────────────────────────── */
export function Skeleton({ className = "", style = {} }) {
  return (
    <div
      aria-hidden="true"
      className={`skeleton ${className}`}
      style={style}
    />
  );
}

export function SkeletonText({ lines = 1, className = "" }) {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className="h-3 w-full"
          style={i === lines - 1 && lines > 1 ? { width: "70%" } : undefined}
        />
      ))}
    </div>
  );
}

export function SkeletonCircle({ size = 40, className = "" }) {
  return (
    <Skeleton
      className={`rounded-full ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function SkeletonButton({ className = "" }) {
  return <Skeleton className={`h-10 w-28 rounded-full ${className}`} />;
}

export function SkeletonCard({ className = "", children }) {
  return (
    <div className={`card-luxe p-6 ${className}`}>
      {children || (
        <div className="flex flex-col gap-4">
          <Skeleton className="h-4 w-1/3" />
          <SkeletonText lines={3} />
        </div>
      )}
    </div>
  );
}

export function SkeletonTable({ rows = 5, columns = 4 }) {
  return (
    <div className="card-luxe overflow-hidden p-2">
      <div className="flex flex-col gap-3 p-3">
        {Array.from({ length: rows }).map((_, r) => (
          <div key={r} className="flex gap-4">
            {Array.from({ length: columns }).map((_, c) => (
              <Skeleton
                key={c}
                className="h-4 flex-1"
                style={{ maxWidth: c === 0 ? "30%" : undefined }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Skeleton;
